module.exports = __webpack_public_path__ + "static/media/DubaiW23-Medium.045d35b9.eot";